module.exports = __webpack_public_path__ + "static/media/customer-picture.b58f44b8.png";